import axios from '../lib/dm_axios';
import path from '../config/path';

const rootPath = path.apiRootPath;

var AuthenticationManager = {};

AuthenticationManager.authenticate = async function(phoneNumber) {
  try {
    var user = await axios.post(rootPath + 'auth/authenticate', {
      phoneNumber,
    });
    return user;
  } catch (err) {
    console.log(err);
  }
};

AuthenticationManager.updateProfile = async function(profile) {
  try {
    var user = await axios.post(rootPath + 'users/profile', { profile });
    return user;
  } catch (err) {
    console.log(err);
  }
};

export default AuthenticationManager;
